module.exports = __webpack_public_path__ + "static/media/mt4.054fab64.jpg";